/* ============================================================================
   Ancona Pass 25 — saved-to-cart bridge (ancona-saved-cart.js)  [B8 + B10]
   Two independently-flagged, additive features layered onto the FROZEN Pass
   12/13 Saved Pieces dialogs (hooked only through their public CustomEvents
   and shared storage — the frozen files are not modified):
   1. add-to-cart (B8): Saved is no longer a one-way street. When a Saved
      dialog opens, every row whose stored URL carries the exact variant
      (?variant=…, written by Pass 19/20) gains an "Add to cart" button that
      POSTs the native /cart/add.js (locale-root-safe via Shopify.routes) and
      refreshes the header cart bubble. Rows saved without a variant (older
      entries) keep their PDP link — choosing options belongs on the PDP.
   2. send-self (B10): cross-device continuity over the existing /?shortlist=
      bridge. The Saved dialog gains "Send this list to yourself"
      (navigator.share → mailto → copy), and the Pass 25 shared-shortlist
      strip (ancona-shortlist-plus.js, event ancona:shortlist2_open) gains
      "Save these to my list", importing shared pieces into the same
      ancona:v1:saved store — never evicting existing saves past its cap of 24.
   No PII, no cookies, no server storage; the only network write is the native
   cart add the shopper explicitly clicks.
   Feature flags: this <script> tag's data-ancona-savedcart attribute (tokens:
   add-to-cart | send-self). Absent attribute -> all; empty string -> none.
   Revert: remove the two data-ancona-savedcart lines in layout/theme.liquid +
   this file + assets/ancona-saved-cart.css.
   ============================================================================ */
(function () {
  'use strict';
  try {
    if (window.__anconaSavedCart) return;
    window.__anconaSavedCart = true;

    var script = document.currentScript;
    var featAttr = script ? script.getAttribute('data-ancona-savedcart') : null;
    /* Absent attribute → all features; explicit empty string → none (documented revert path). */
    var FEATURES = (featAttr == null ? 'add-to-cart,send-self' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!FEATURES.length) return;
    function on(f) { return FEATURES.indexOf(f) !== -1; }

    function track(ev, payload) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: 'ancona:' + ev }, payload || {}));
        document.dispatchEvent(new CustomEvent('ancona:' + ev, { detail: payload || {} }));
      } catch (e) { /* analytics must never break shopping */ }
    }

    var LS = null;
    try { LS = window.localStorage; LS.setItem('ancona:v1:t', '1'); LS.removeItem('ancona:v1:t'); } catch (e) { LS = null; }

    var SAVED_KEY = 'ancona:v1:saved'; /* owned by Pass 12 — same {h,u,t,p,i,ts} shape, cap 24 */
    var SAVED_CAP = 24;
    function savedList() {
      if (!LS) return [];
      try {
        var v = JSON.parse(LS.getItem(SAVED_KEY));
        return Array.isArray(v) ? v.filter(function (x) { return x && typeof x.h === 'string' && typeof x.u === 'string'; }) : [];
      } catch (e) { try { LS.removeItem(SAVED_KEY); } catch (_) {} return []; }
    }
    function savedWrite(list) {
      if (!LS) return false;
      try { LS.setItem(SAVED_KEY, JSON.stringify(list.slice(0, SAVED_CAP))); return true; } catch (e) { return false; }
    }
    function savedHas(h) { return savedList().some(function (x) { return x.h === h; }); }

    /* Locale/market-safe root (same pattern as ancona-cart-save.js). */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function rootUrl(path) { return root.replace(/\/$/, '') + '/' + String(path).replace(/^\//, ''); }

    /* Polite live region. When a dialog is open the announcement must live
       INSIDE it (same reasoning as the frozen layers); otherwise page-level. */
    function announceIn(container, msg) {
      try {
        var host = container || document.body;
        var lr = host.querySelector(':scope > .ancona-savedcart-live');
        if (!lr) {
          lr = document.createElement('div');
          lr.className = 'ancona-visually-hidden ancona-savedcart-live';
          lr.setAttribute('aria-live', 'polite');
          lr.setAttribute('role', 'status');
          host.appendChild(lr);
        }
        lr.textContent = '';
        window.setTimeout(function () { lr.textContent = msg; }, 30);
      } catch (e) {}
    }

    /* ---- 1) add-to-cart (B8) ---------------------------------------------- */
    function refreshCartIcon(sections) {
      try {
        var html = sections && sections['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var inner = tpl.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : html;
      } catch (e) { /* a stale bubble is cosmetic; the cart itself is correct */ }
    }

    function addToCart(btn, variantId, handle, body) {
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var label = btn.textContent;
      btn.textContent = 'Adding…';
      fetch(rootUrl('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-icon-bubble' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
        .then(function (res) {
          delete btn.dataset.busy;
          if (res.ok && !res.json.status) {
            btn.textContent = 'Added to cart';
            btn.disabled = true;
            refreshCartIcon(res.json.sections);
            announceIn(body, 'Added to cart.');
            track('saved_cart_add', { handle: handle, variant: String(variantId) });
            window.setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
          } else if (res.status === 422) {
            /* Truthful availability state — no retry theater. A 422 is not
               always "sold out" (it also means "everything available is
               already in your cart"), so Shopify's own description is the
               source of truth when it is present. */
            var why = (res.json && typeof res.json.description === 'string') ? res.json.description : '';
            if (!why || /sold out/i.test(why)) {
              btn.textContent = 'Sold out';
              btn.disabled = true;
              announceIn(body, why || 'This piece is sold out.');
            } else {
              btn.textContent = label;
              announceIn(body, why);
            }
          } else {
            btn.textContent = label;
            announceIn(body, 'Could not add this piece to the cart. The cart is unchanged.');
          }
        })
        ['catch'](function () {
          delete btn.dataset.busy;
          btn.textContent = label;
          announceIn(body, 'Could not add this piece to the cart. The cart is unchanged.');
        });
    }

    function decorateRows(dlg) {
      var body = dlg.querySelector('.ancona-dlg__body') || dlg;
      var rows = dlg.querySelectorAll('.ancona-dlg__item');
      Array.prototype.forEach.call(rows, function (li) {
        if (li.dataset.anconaSavedCart) return;
        li.dataset.anconaSavedCart = '1';
        var a = li.querySelector('a[href*="/products/"]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        var vm = /[?&]variant=(\d+)/.exec(href);
        if (!vm) return; /* no exact variant stored — the PDP link is the honest path */
        var hm = /\/products\/([a-z0-9][a-z0-9-]*)/i.exec(href);
        var handle = hm ? hm[1] : '';
        var titleEl = li.querySelector('.ancona-dlg__t');
        var title = titleEl ? (titleEl.textContent || '').trim() : handle;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ancona-savedcart__add';
        btn.textContent = 'Add to cart';
        btn.setAttribute('aria-label', 'Add to cart: ' + (title || handle));
        btn.addEventListener('click', function () { addToCart(btn, vm[1], handle, body); });
        var rm = li.querySelector('.ancona-dlg__rm');
        li.insertBefore(btn, rm || null);
      });
    }

    /* ---- 2) send-self (B10a): "Send this list to yourself" ----------------- */
    function shortlistUrl() {
      var handles = savedList().slice(0, 8).map(function (x) { return x.h; });
      if (!handles.length) return null;
      return location.origin + root + '?shortlist=' + handles.map(encodeURIComponent).join(',');
    }

    function decorateSend(dlg) {
      var actions = dlg.querySelector('.ancona-dlg__actions');
      if (!actions || actions.querySelector('.ancona-savedcart-send')) return; /* idempotent */
      if (!savedList().length) return; /* nothing to send */
      var body = dlg.querySelector('.ancona-dlg__body') || dlg;
      var send = document.createElement('button');
      send.type = 'button';
      send.className = 'ancona-savedcart-send';
      send.textContent = 'Send this list to yourself';
      send.addEventListener('click', function () {
        var url = shortlistUrl();
        if (!url) { announceIn(body, 'Nothing saved yet.'); return; }
        var count = Math.min(savedList().length, 8);
        track('shortlist_share', { count: count, channel: 'self' });
        if (navigator.share) {
          navigator.share({ title: 'Your Ancona shortlist', url: url })['catch'](function () {});
        } else {
          /* Open the shopper's own mail client with the link prefilled — no
             address is collected or stored by the site. */
          try {
            window.location.href = 'mailto:?subject=' + encodeURIComponent('Your Ancona shortlist') +
              '&body=' + encodeURIComponent('Your saved pieces at Ancona:\n' + url);
          } catch (e) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(url).then(function () {
                announceIn(body, 'Link copied.');
                send.textContent = 'Link copied';
                window.setTimeout(function () { send.textContent = 'Send this list to yourself'; }, 2000);
              })['catch'](function () { window.prompt('Copy this shortlist link:', url); });
            } else {
              window.prompt('Copy this shortlist link:', url);
            }
          }
        }
      });
      actions.appendChild(send);
    }

    function decorateSavedDialog() {
      /* The dialog is built synchronously by the frozen layers; defer one tick
         (same pattern as ancona-deluxe.js) so it is in the DOM. */
      window.setTimeout(function () {
        try {
          var dlgs = document.querySelectorAll('.ancona-dlg[role="dialog"]');
          var dlg = dlgs.length ? dlgs[dlgs.length - 1] : null;
          if (!dlg || !/saved pieces/i.test(dlg.getAttribute('aria-label') || '')) return;
          if (on('add-to-cart')) decorateRows(dlg);
          if (on('send-self')) decorateSend(dlg);
        } catch (e) { /* decoration must never break the dialog */ }
      }, 0);
    }

    /* ---- 2b) send-self (B10b): import from the shared-shortlist strip ------
       ancona-shortlist-plus.js dispatches ancona:shortlist2_open with
       detail.items = [{h,u,t,p,i}] and renders an .ancona-sl2__actions slot. */
    function initShortlistImport() {
      document.addEventListener('ancona:shortlist2_open', function (e) {
        try {
          if (!LS) return;
          var items = e && e.detail && Array.isArray(e.detail.items) ? e.detail.items : [];
          if (!items.length) return;
          var slot = document.querySelector('.ancona-sl2__actions');
          if (!slot || slot.querySelector('.ancona-savedcart-import')) return; /* idempotent */
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ancona-savedcart-import';
          btn.textContent = 'Save these to my list';
          btn.addEventListener('click', function () {
            var list = savedList();
            var space = SAVED_CAP - list.length;
            var candidates = items.filter(function (x) { return x && typeof x.h === 'string' && typeof x.u === 'string' && !savedHas(x.h); });
            if (!candidates.length) { announceIn(slot.closest('.ancona-sl2'), 'These pieces are already in your saved list.'); return; }
            var toAdd = candidates.slice(0, Math.max(space, 0));
            if (!toAdd.length) { announceIn(slot.closest('.ancona-sl2'), 'Your saved list is full (24 pieces). Remove some to import.'); return; }
            toAdd.forEach(function (x) {
              list.unshift({ h: x.h, u: x.u, t: String(x.t || x.h).slice(0, 80), p: String(x.p || '').slice(0, 24), i: x.i || '', ts: Date.now() });
            });
            if (!savedWrite(list)) { announceIn(slot.closest('.ancona-sl2'), 'Saving is unavailable in this browser.'); return; }
            /* One factual event: pieces were added to the shared Saved store.
               The frozen launch.js hub listener refreshes on this. */
            track('saved_add', { source: 'shortlist-import', count: toAdd.length });
            var msg = toAdd.length === candidates.length
              ? 'Saved ' + toAdd.length + (toAdd.length === 1 ? ' piece' : ' pieces') + ' to your list.'
              : 'Saved ' + toAdd.length + ' of ' + candidates.length + ' pieces — your list holds up to 24.';
            announceIn(slot.closest('.ancona-sl2'), msg);
            btn.textContent = 'Saved to your list';
            btn.disabled = true;
          });
          slot.appendChild(btn);
        } catch (err) { /* import must never break the strip */ }
      });
    }

    function boot() {
      if (!LS) return; /* both features depend on the Saved store */
      /* Header hub dialog announces itself via the Pass 13 CustomEvent … */
      document.addEventListener('ancona:saved_open', decorateSavedDialog);
      /* … the PDP "Your saved pieces (n)" trigger (Pass 12) opens without an
         event — hook its click directly (same targeted pattern as deluxe.js). */
      var savedTrigger = document.getElementById('AnconaSavedOpen');
      if (savedTrigger) savedTrigger.addEventListener('click', decorateSavedDialog);
      if (on('send-self')) { try { initShortlistImport(); } catch (e) {} }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* the saved-cart bridge must never break the page */ }
})();
